import { useGetMe } from '@/api/user.api';
import Loader from '@/components/ui/Loader';
import ReceiverProfileForm from '@/components/profile/ReceiverProfileForm';
import { useMemo } from 'react';
import { UserType } from '@/types/auth/UserType';
import DistributorProfileForm from '@/components/profile/DistributorProfileForm';

const ProfilePage = () => {
  const { data: userData, isLoading, isSuccess } = useGetMe();

  const userType: UserType | null = useMemo(
    () => (isSuccess ? userData?.userType : null),
    [isSuccess, userData?.userType],
  );

  return isLoading ? (
    <Loader />
  ) : isSuccess ? (
    <>
      {userType === UserType.Distributor && (
        <DistributorProfileForm
          userData={userData}
          isAdmin={userData.isAdmin ?? false}
          key={userData.id}
        />
      )}
      {userType === UserType.Receiver && (
        <ReceiverProfileForm
          userData={userData}
          isAdmin={userData.isAdmin ?? false}
          key={userData.id}
        />
      )}
    </>
  ) : null;
};

export default ProfilePage;
